export default __webpack_public_path__ + "static/media/main_info_data_08.558ff846.png";